import React from 'react';
import { Navigate, Route, Routes } from "react-router-dom";
import Profile from '../components/profile'
import PlayGames from '../components/play'
import LossGames from '../components/loss'
import History from '../components/history'
import Edit from '../components/editProfile'
import Policy from '../components/policy'
import ModalPlay from '../components/modelPlay'
import WinGames from '../components/win'
import Language from '../components/language'
import Contactus from '../components/contactUs'
import Screen2 from '../components/screen2'
import Screen3 from '../components/screen3'
import AllQuizes from '../components/allQuizes'
import GameDetails from '../components/gameDetails'
import LeaderBoard from '../components/leaderBoard'
import FindingOpponent from '../components/findingOpponent'
import Login from '../components/login/login'
import Championship from '../components/championship'
import ChampionshipDetail from '../components/championshipDetail'
import ChampionshipPlay from '../components/championshipPlay'
import ChampionshipResult from '../components/championshipResult'
import Unsub from '../components/login/unsub'
import Faq from '../components/faq'
import Terms from '../components/terms'
import PlaySolo from '../components/PlaySolo';
import Redeem from '../components/redeem';
import UpgradePack from '../components/login/upgradePack';
import UpdatePack from '../components/updatePack';
import PromoLeaderboard from '../components/promoLeaderboard';
import PromoGame from '../components/PromoGame';
import Rules from '../components/Rules';
import PromoLimit from '../components/promoLimit';
import PromoRules from '../components/promoRules';
import PromoQuiz from '../components/promoQuiz';
import PromoGame2 from '../components/promoGame2';
import SuccessTopupContest from '../components/successTopupcontest';

const ProtectedRoute = () => {

    return (
        <Routes>
            <Route exact path='/' element={<Screen2 />} />
            <Route path='/home' element={<Screen2 />} />
            <Route path='/levels' element={<Screen3 />} />
            <Route path='/moregames' element={<AllQuizes />} />
            <Route path='/gamedetails' element={<GameDetails />} />
            <Route path='/leaderboard' element={<LeaderBoard />} />
            <Route path='/finding' element={<FindingOpponent />} />
            <Route path='/championship' element={<Championship />} />
            <Route path='/championship/detail/:id' element={<ChampionshipDetail />} />
            <Route path='/championship/play' element={<ChampionshipPlay />} />
            <Route path='/championship/result/:id' element={<ChampionshipResult />} />
            <Route path='/upgrade' element={<UpgradePack />} />
            <Route path='/redeem' element={<Redeem />} />
            <Route path='/updatePack' element={<UpdatePack />} />

            <Route path='/profile' element={<Profile />} />
            <Route path='/play' element={<PlayGames />} />
            <Route path='/play-solo' element={<PlaySolo />} />
            <Route path='/loss' element={<LossGames />} />
            <Route path='/history' element={<History />} />
            <Route path='/edit' element={<Edit />} />
            <Route path='/policy' element={<Policy />} />
            <Route path='/modal' element={<ModalPlay />} />
            <Route path='/won' element={<WinGames />} />
            <Route path='/language' element={<Language />} />
            <Route path='/contactus' element={<Contactus />} />
            <Route path='/unsub' element={<Unsub />} />
            <Route path='/faq' element={<Faq />} />
            <Route path='/terms' element={<Terms />} />

            <Route path='/promo/leaderboard' element={<PromoLeaderboard />} />
            {/* <Route path='/promo/game' element={<PromoGame />} /> */}
            <Route path='/promo/game2' element={<PromoGame2 />} />
            <Route path='/promo/rules' element={<PromoRules />} />
            <Route path='/promo/quiz' element={<PromoQuiz />} />

            <Route path='/promo/limit' element={<PromoLimit />} />
            <Route path='/success/topupContest' element={<SuccessTopupContest />} />

        </Routes>
    )

};

export default ProtectedRoute;